import { validateContentReference } from '@gitbook/app-content-refs';
import { Schema } from '@gitbook/slate';

import { BLOCK_IF, BLOCK_OPENAPI_OPERATION } from '../types';

const validateOpenApiRef = validateContentReference(['openapi']);

/*
 * Schema to validate OpenAPI Operation blocks.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_OPENAPI_OPERATION]: {
            parent: { objects: ['document', 'block'], types: [undefined, BLOCK_IF] },
            isVoid: true,
            data: {
                path: (data: unknown) => typeof data === 'string',
                method: (data: unknown) => typeof data === 'string',
                ref: (data: unknown) => validateOpenApiRef(data),
                headless: (data: unknown) => data === undefined || typeof data === 'boolean',
            },
        },
    },
});
